import { dayjs } from "Config/dayjs";

const UUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const formatMcpTs = (value?: string | number) => {
  if (value == null || value === "") {
    return "—";
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("lll") : "—";
};

export const isMcpOauthClientId = (value?: string) => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) {
    return false;
  }
  if (UUID.test(trimmed)) {
    return true;
  }
  try {
    const uri = new URL(trimmed);
    return uri.protocol === "http:" || uri.protocol === "https:";
  } catch {
    return false;
  }
};

export const isHttpUrl = (value?: string) => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) {
    return false;
  }
  try {
    const uri = new URL(trimmed);
    return uri.protocol === "http:" || uri.protocol === "https:";
  } catch {
    return false;
  }
};

export const isUriWithScheme = (value?: string) => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) {
    return false;
  }
  try {
    const uri = new URL(trimmed);
    return Boolean(uri.protocol);
  } catch {
    return /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed);
  }
};

export const MCP_OVERVIEW_WINDOWS = ["1d", "7d", "30d", "all"] as const;
export type McpOverviewWindow = (typeof MCP_OVERVIEW_WINDOWS)[number];

export const parseMcpOverviewWindow = (raw?: string | null): McpOverviewWindow => {
  const window = (raw ?? "").trim().toLowerCase();
  if (window === "1d" || window === "24h" || window === "day") {
    return "1d";
  }
  if (window === "30d" || window === "month") {
    return "30d";
  }
  if (window === "all") {
    return "all";
  }
  return "7d";
};

export const redirectUrisAreValid = (value?: string) => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) {
    return true;
  }
  return trimmed
    .split(/[,\s]+/)
    .filter(Boolean)
    .every((part) => isUriWithScheme(part));
};
